import React from 'react';

interface LogoProps {
  white?: boolean;
  height?: number;
  className?: string;
}

export function Logo({ white = false, height = 36, className = '' }: LogoProps) {
  return (
    <img
      src="/images/logos/tipbuddy_logo_colored.png"
      alt="tipbuddy"
      height={height}
      style={{
        height,
        width: 'auto',
        filter: white ? 'brightness(0) invert(1)' : undefined,
      }}
      className={className}
    />
  );
}
